// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__knXjD","button":"styles_button__tye2v","details":"styles_details__Y_xf9"};